import React from 'react'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import NightsStayIcon from '@material-ui/icons/NightsStay'
import MenuBookIcon from '@material-ui/icons/MenuBook'
import PersonIcon from '@material-ui/icons/Person'
import { NavLink } from 'react-router-dom'

const NAV_TEXT = '#1a1a1a'
const NAV_ACTIVE = '#72568e'

const useStyles = makeStyles((theme) => ({
  nav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(0.5),
  },
  navLink: {
    textDecoration: 'none',
    color: NAV_TEXT,
    borderBottom: '2px solid transparent',
    paddingBottom: 2,
  },
  navLinkActive: {
    color: `${NAV_ACTIVE} !important`,
    fontWeight: 700,
    borderBottom: `2px solid ${NAV_ACTIVE}`,
  },
  navBtn: {
    textTransform: 'none',
    fontWeight: 600,
    color: 'inherit',
    minWidth: 86,
    minHeight: 48,
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      padding: theme.spacing(0.5, 1),
    },
  },
}))

const TABS = [
  {
    label: 'Tonight',
    to: '/tonight',
    match: (path) => path === '/tonight',
    icon: <NightsStayIcon fontSize="small" />,
  },
  {
    label: 'Library',
    to: '/library',
    match: (path) =>
      path === '/library' ||
      path === '/' ||
      path.startsWith('/story/') && !path.startsWith('/story/create'),
    icon: <MenuBookIcon fontSize="small" />,
  },
  {
    label: 'You',
    to: '/you',
    match: (path) =>
      path === '/you' ||
      path === '/profile' ||
      path === '/settings' ||
      path.startsWith('/profile/'),
    icon: <PersonIcon fontSize="small" />,
  },
]

export default function StoryworldMainNav() {
  const classes = useStyles()

  return (
    <nav className={classes.nav} aria-label="Main">
      {TABS.map(({ label, to, match, icon }) => (
        <NavLink
          key={to}
          to={to}
          className={classes.navLink}
          activeClassName={classes.navLinkActive}
          isActive={(_, loc) => match(loc.pathname)}
        >
          <Button className={classes.navBtn} startIcon={icon} color="inherit">
            <Typography component="span" style={{ fontWeight: 'inherit', fontSize: 'inherit' }}>
              {label}
            </Typography>
          </Button>
        </NavLink>
      ))}
    </nav>
  )
}
